import noop from 'lodash/noop';
import { getContext, Symbols } from 'choerodon-ui/shared';
const TabsContext = getContext(Symbols.TabsContext, {
    changeActiveKey: noop,
    saveCustomized: noop,
    groupedPanelsMap: new Map(),
    currentPanelMap: new Map(),
    totalPanelsMap: new Map(),
});
export default TabsContext;
